import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

import { BaseChildComponent } from '@components/_base/base-child/base-child.component';
import { CustomerService } from '@app/customers/_services/customer.service';
import { catchError, repeatWhen, tap } from 'rxjs/operators';
import { CustomerReminder } from '@app/customers/_models/customer-reminder.model';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-client-profile-reminders',
  templateUrl: './client-profile-reminders.component.html',
  styleUrls: ['./client-profile-reminders.component.css']
})
export class ClientProfileRemindersComponent extends BaseChildComponent implements OnInit {
  customerReminders: CustomerReminder[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private translateService: TranslateService
  ) { 
    super();
  }

  ngOnInit(): void { }

  initialize() {
    if (this.isInitialized) return;

    this.customerService.findRemindersByCustomerId(this.parentId).pipe(
      tap(data => this. customerReminders = data),
      catchError(err => {
        console.log(err)
        this.errorMessageSubject.next(this.translateService.instant('messages.errorLoadingData'));
        return EMPTY;
      }),
      repeatWhen(() => this.reload$)
    ).subscribe({
      next: () => this.isInitialized = true})
  }
}
